var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M12 12V0H0v24h12z"})),React.createElement("g",{"fillRule":"evenodd","key":1},[React.createElement("mask",{"key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("path",{"d":"M3 8H0v4h3v12h5V12h3.642L12 8H8V6.333C8 5.378 8.192 5 9.115 5H12V0H8.192C4.596 0 3 1.583 3 4.615V8z","mask":"url(#b)","key":1})])]);
}

Facebook.defaultProps = {"width":"12","height":"24","viewBox":"0 0 12 24"};

module.exports = Facebook;

Facebook.default = Facebook;
